export const CANDIDATE_PERMISSION_CODES = {
    WEB_RECRUITMENT_CANDIDATE_LIST: 'WEB_RECRUITMENT_CANDIDATE_LIST',
    WEB_RECRUITMENT_CANDIDATE_DETAIL: 'WEB_RECRUITMENT_CANDIDATE_DETAIL',
    WEB_RECRUITMENT_CANDIDATE_ADD: 'WEB_RECRUITMENT_CANDIDATE_ADD',
    WEB_RECRUITMENT_CANDIDATE_EDIT: 'WEB_RECRUITMENT_CANDIDATE_EDIT',
    WEB_RECRUITMENT_CANDIDATE_DELETE: 'WEB_RECRUITMENT_CANDIDATE_DELETE',
    WEB_RECRUITMENT_CANDIDATE_IMPORT: 'WEB_RECRUITMENT_CANDIDATE_IMPORT',
    WEB_RECRUITMENT_CANDIDATE_EXPORT: 'WEB_RECRUITMENT_CANDIDATE_EXPORT',
} as const;

